function getDateTimeIndex(input){
  var date = input || new Date();
  return {
    'hour_of_day'  : date.getHours(),
    'day_of_week'  : parseInt( 1 + date.getDay() ),
    'day_of_month' : date.getDate(),
    'month'        : parseInt( 1 + date.getMonth() ),
    'year'         : date.getFullYear()
  };
}

module.exports = getDateTimeIndex;



//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/lib/helpers/getDatetimeIndex.js
// module id = 1978
// module chunks = 0